export default class ComplaintSeverity {
  public id = 0
  public description = ''

  public constructor(id: number, description: string) {
    this.id = id
    this.description = description
  }
}
